import React from "react";

const SIZES = { sm: "av--sm", md: "", lg: "av--lg", xl: "av--xl" };

const initials = (str = "") => {
  const parts = String(str).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const Avatar = ({ src, name = "", size = "md", className = "", style, ...rest }) => (
  <span className={`av ${SIZES[size] || ""} ${className}`.trim()} style={style} title={name} {...rest}>
    {src ? <img src={src} alt={name || "avatar"} /> : initials(name)}
  </span>
);

export default Avatar;
